export default __webpack_public_path__ + "static/media/setting_5.d3dc9079.png";